module.exports = __webpack_public_path__ + "static/media/shiluojia_match_01.0d55a741.png";